import React from "react"
import { Box, Divider, Button, Grid, Collapse } from "@material-ui/core"

const YesNoNaStep = ({ expand, value, buttonClass, onClick, disabled, classes }) => {
  const handleClick = (...args) => {
    onClick && onClick(...args)
  }

  return (
    <Collapse in={expand}>
      <Divider className={classes.divider} />
      <Box py={1} px={2}>
        <Grid container spacing={1}>
          <YesNoNaButton answer="Yes" value={value} onClick={handleClick} className={buttonClass} disabled={disabled} />
          <YesNoNaButton answer="No" value={value} onClick={handleClick} className={buttonClass} disabled={disabled} />
          <YesNoNaButton answer="N/A" value={value} onClick={handleClick} className={buttonClass} disabled={disabled} />
        </Grid>
      </Box>
    </Collapse>
  )
}

const YesNoNaButton = ({ answer, value, onClick, className, disabled: disabledInput }) => {
  const selected = !!value && answer.toLowerCase() === value.toLowerCase()
  const disabled = !!value && !selected

  const handleClick = (event) => {
    onClick && onClick(event, answer.toLowerCase())
  }

  return (
    <Grid item xs={4}>
      <Button
        color={selected ? "primary" : "default"}
        variant={disabled ? "text" : "contained"}
        fullWidth
        onClick={handleClick}
        className={className}
        disabled={disabled || disabledInput}
      >
        {answer}
      </Button>
    </Grid>
  )
}

export { YesNoNaStep }
